module.exports = __webpack_public_path__ + "static/media/testing_jest.369f0112.webp";